import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="col-span-1">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_8b43b00b-d49b-410d-b712-afa38bbd140c/artifacts/ii0uiy7q_sodin%20azul%20.png" 
                alt="Grupo Sodin" 
                className="h-20 mb-4"
              />
            </div>
            <p className="text-gray-400 text-sm">
              Todos os direitos autorais pertencem ao Grupo Sodin. Marca registrada Grupo Sodin.
            </p>
          </div>

          {/* Mapa do Site */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Mapa do site</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-400 hover:text-green-500 transition-colors">Início</Link></li>
              <li><Link to="/produtos-servicos" className="text-gray-400 hover:text-green-500 transition-colors">Produtos e Serviços</Link></li>
              <li><Link to="/trabalhe-conosco" className="text-gray-400 hover:text-green-500 transition-colors">Trabalhe conosco</Link></li>
              <li><Link to="/parceiros" className="text-gray-400 hover:text-green-500 transition-colors">Parceiros</Link></li>
              <li><Link to="/contato" className="text-gray-400 hover:text-green-500 transition-colors">Fale Conosco</Link></li>
            </ul>
          </div>

          {/* Fale Conosco */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Fale Conosco</h3>
            <div className="space-y-3 text-sm text-gray-400">
              <p>Av. Jô Sato, 1953</p>
              <p>Novo Tempo, Vilhena - RO</p>
              <a 
                href="https://api.whatsapp.com/send?phone=556933214548" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 hover:text-green-500 transition-colors"
              >
                <span>(69) 3321-4548</span>
              </a>
            </div>
          </div>

          {/* Redes Sociais */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Redes sociais</h3>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Grupo Sodin. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;